"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIncomePredictionAmount = exports.NotFoundInCashflowError = exports.splitTransaction = exports.setSequenceComment = exports.setTransactionComment = exports.changeTransactionCategory = exports.moveFromTracking = exports.changeCategory = exports.moveExcludedToVariableIncome = exports.moveExcludedToVariableExpense = exports.moveVariableIncomeToFixed = exports.moveExpenseToFixed = exports.moveVariableExpenseToFixed = exports.excludeIncome = exports.excludeVariableIncome = exports.excludeExpense = exports.excludeVariableExpense = exports.exclude = exports.moveExcludedToVariable = exports.removeFromExcluded = exports.markAsNotExcluded = exports.showTrackingCategory = exports.moveToFixed = exports.putOnFixed = exports.popTransaction = exports.popTransactionAndContainingEnvelope = exports.moveFixedToVariable = exports.changeEnvelopeExpenseCategory = exports.updateRiseupGoalAmount = exports.updateEnvelopeAmount = exports.moveExpensesToVariable = exports.cancelEnvelope = void 0;
const lodash_1 = __importDefault(require("lodash"));
const ts_essentials_1 = require("ts-essentials");
const enums_1 = require("../types/enums");
const utils_1 = require("./utils");
const consts_1 = require("../consts");
function cancelEnvelope(cashflow, envelopeId) {
    const index = lodash_1.default.findIndex(cashflow.envelopes, envelope => envelope.id === envelopeId);
    _assertIndex(index, 'envelope to cancel');
    moveExpensesToVariable(cashflow, cashflow.envelopes[index]);
    cashflow.envelopes.splice(index, 1);
}
exports.cancelEnvelope = cancelEnvelope;
function moveExpensesToVariable(cashflow, envelope) {
    // eslint-disable-next-line no-param-reassign
    cashflow.variableTransactions = cashflow.variableTransactions.concat(envelope.actuals);
    // eslint-disable-next-line no-param-reassign
    envelope.actuals = [];
}
exports.moveExpensesToVariable = moveExpensesToVariable;
function updateEnvelopeAmount(cashflow, envelopeId, amount, isCustomPrediction) {
    const envelope = lodash_1.default.find(cashflow.envelopes, envelope => envelope.id === envelopeId);
    envelope.predictedAmount = amount;
    envelope.isCustomPrediction = isCustomPrediction;
}
exports.updateEnvelopeAmount = updateEnvelopeAmount;
function updateRiseupGoalAmount(cashflow, amount) {
    const envelope = lodash_1.default.find(cashflow.envelopes, e => e.type === enums_1.EnvelopeType.RiseUpGoal);
    if (!envelope) {
        throw new Error('updateRiseupGoalAmount called with no RiseUpGoal envelope');
    }
    envelope.predictedAmount = amount;
    if (envelope.details) {
        envelope.details.riseupGoalInputAmount = amount;
    }
}
exports.updateRiseupGoalAmount = updateRiseupGoalAmount;
function changeEnvelopeExpenseCategory(cashflow, envelopeId, expenseCategory) {
    const envelope = lodash_1.default.find(cashflow.envelopes, envelope => envelope.id === envelopeId);
    if (!envelope) {
        throw new Error('changeEnvelopeExpenseCategory called on non-existing envelope');
    }
    envelope.details.expense = expenseCategory;
}
exports.changeEnvelopeExpenseCategory = changeEnvelopeExpenseCategory;
function moveFixedToVariable(cashflow, transactionId) {
    const envelope = _findFixedEnvelopeWithTransaction(cashflow, transactionId);
    if (!envelope) {
        throw new Error('moveFixedToVariable called on non-existing envelope');
    }
    const transaction = envelope.actuals.pop();
    if (!transaction) {
        throw new Error('moveFixedToVariable: transaction not found in envelope actuals');
    }
    // @ts-expect-error
    transaction.sequenceId = undefined;
    if (transaction.isIncome) {
        cashflow.variableIncomeTransactions.push(transaction);
    }
    else {
        cashflow.variableTransactions.push(transaction);
    }
    _popEnvelope(cashflow, envelope.id);
}
exports.moveFixedToVariable = moveFixedToVariable;
function _popEnvelope(cashflow, envelopeId) {
    const index = lodash_1.default.findIndex(cashflow.envelopes, envelope => envelope.id === envelopeId);
    _assertIndex(index, 'envelope to cancel');
    cashflow.envelopes.splice(index, 1);
}
function _findFixedEnvelopeWithTransaction(cashflow, transactionId) {
    return lodash_1.default.find(cashflow.envelopes, envelope => { var _a; return envelope.actuals.length > 0 && ((_a = lodash_1.default.first(envelope.actuals)) === null || _a === void 0 ? void 0 : _a.transactionId) === transactionId && envelope.type === enums_1.EnvelopeType.Fixed; });
}
function popTransactionAndContainingEnvelope(cashflow, transactionId, transactionList) {
    const fixedEnvelope = _findFixedEnvelopeWithTransaction(cashflow, transactionId);
    const transaction = popTransaction(cashflow, transactionId, transactionList);
    if (!transaction) {
        throw new Error('popTransactionAndContainingEnvelope: transaction not found');
    }
    if (fixedEnvelope) {
        _popEnvelope(cashflow, fixedEnvelope.id);
    }
    return transaction;
}
exports.popTransactionAndContainingEnvelope = popTransactionAndContainingEnvelope;
function popTransaction(cashflow, transactionId, transactionList) {
    const transactionIndex = lodash_1.default.findIndex(transactionList, t => t.transactionId === transactionId);
    _assertIndex(transactionIndex, 'transaction to exclude');
    const [transaction] = transactionList.splice(transactionIndex, 1);
    if (!transaction) {
        throw new Error('popTransaction: transaction not found');
    }
    return transaction;
}
exports.popTransaction = popTransaction;
function putOnFixed(cashflow, transaction, expense) {
    cashflow.envelopes.push(utils_1.fixedEnvelopeFromTransaction(lodash_1.default.assign(transaction, expense && { expense })));
}
exports.putOnFixed = putOnFixed;
function moveToFixed(cashflow, transactionId, transactionList, expense) {
    const transaction = popTransaction(cashflow, transactionId, transactionList);
    putOnFixed(cashflow, transaction, expense);
    return transaction;
}
exports.moveToFixed = moveToFixed;
function showTrackingCategory(cashflow, name, amount, trackingCategoryId, icon, frequency, isCustomPrediction, defaultAmount, dateLocale) {
    const trackingCategoryEnvelopes = utils_1.createTrackingCategoryEnvelope(name, icon, amount, trackingCategoryId, cashflow.budgetDate, frequency, isCustomPrediction, defaultAmount, cashflow.cashflowStartDay, dateLocale);
    cashflow.envelopes.push(...trackingCategoryEnvelopes);
}
exports.showTrackingCategory = showTrackingCategory;
function markAsNotExcluded(transaction) {
    transaction.excluded = false;
    transaction.excludeReason = undefined;
}
exports.markAsNotExcluded = markAsNotExcluded;
function removeFromExcluded(cashflow, transactionId) {
    const transaction = popTransaction(cashflow, transactionId, cashflow.excluded);
    markAsNotExcluded(transaction);
    return transaction;
}
exports.removeFromExcluded = removeFromExcluded;
function moveExcludedToVariable(cashflow, transactionId, targetTransactionList) {
    const transaction = removeFromExcluded(cashflow, transactionId);
    targetTransactionList.push(transaction);
    return transaction;
}
exports.moveExcludedToVariable = moveExcludedToVariable;
function exclude(cashflow, transactionId, transactionList, popEnvelope = false, excludeReason = enums_1.ExcludeReason.CustomerRule) {
    const transaction = lodash_1.default.find(transactionList, t => t.transactionId === transactionId);
    if (popEnvelope) {
        popTransactionAndContainingEnvelope(cashflow, transactionId, transactionList);
    }
    else {
        popTransaction(cashflow, transactionId, transactionList);
    }
    const transactionWithExcludeReason = _transactionWithExcludeReason(transaction, excludeReason);
    cashflow.excluded.push(transactionWithExcludeReason);
    return transactionWithExcludeReason;
}
exports.exclude = exclude;
function _transactionWithExcludeReason(transaction, excludeReason) {
    return lodash_1.default.assign({}, transaction, { excludeReason, placement: 'excluded' });
}
function excludeVariableExpense(cashflow, transactionId) {
    exclude(cashflow, transactionId, cashflow.variableTransactions);
}
exports.excludeVariableExpense = excludeVariableExpense;
function excludeExpense(cashflow, transactionId, popEnvelope, excludeReason = enums_1.ExcludeReason.CustomerRule) {
    const sourceTransactions = utils_1.findSourceTransactionsByTransactionId(cashflow, transactionId);
    return exclude(cashflow, transactionId, sourceTransactions, popEnvelope, excludeReason);
}
exports.excludeExpense = excludeExpense;
function excludeVariableIncome(cashflow, transactionId) {
    exclude(cashflow, transactionId, cashflow.variableIncomeTransactions);
}
exports.excludeVariableIncome = excludeVariableIncome;
function excludeIncome(cashflow, transactionId) {
    exclude(cashflow, transactionId, cashflow.excluded);
}
exports.excludeIncome = excludeIncome;
function moveVariableExpenseToFixed(cashflow, transactionId) {
    moveToFixed(cashflow, transactionId, cashflow.variableTransactions);
}
exports.moveVariableExpenseToFixed = moveVariableExpenseToFixed;
function moveExpenseToFixed(cashflow, transactionId, expense) {
    const sourceTransactions = utils_1.findSourceTransactionsByTransactionId(cashflow, transactionId);
    moveToFixed(cashflow, transactionId, sourceTransactions, expense);
}
exports.moveExpenseToFixed = moveExpenseToFixed;
function moveVariableIncomeToFixed(cashflow, transactionId) {
    const transaction = moveToFixed(cashflow, transactionId, cashflow.variableIncomeTransactions);
    if (!transaction) {
        throw new Error('moveVariableIncomeToFixed: transaction not found');
    }
    if (cashflow.params.variableIncomePredictionAmount) {
        // eslint-disable-next-line no-param-reassign
        cashflow.params.variableIncomePredictionAmount -= transaction.incomeAmount;
    }
}
exports.moveVariableIncomeToFixed = moveVariableIncomeToFixed;
function moveExcludedToVariableExpense(cashflow, transactionId) {
    moveExcludedToVariable(cashflow, transactionId, cashflow.variableTransactions);
}
exports.moveExcludedToVariableExpense = moveExcludedToVariableExpense;
function moveExcludedToVariableIncome(cashflow, transactionId) {
    moveExcludedToVariable(cashflow, transactionId, cashflow.variableIncomeTransactions);
}
exports.moveExcludedToVariableIncome = moveExcludedToVariableIncome;
function _isExcludedTransaction(cashflow, transactionId) {
    return lodash_1.default.some(cashflow.excluded, t => t.transactionId === transactionId);
}
function changeCategory(cashflow, businessName, expense, transactionId, applyTo, popEnvelope) {
    if (applyTo === consts_1.ENRICHMENT_INPUT_TYPES.TRANSACTION_ID) {
        _changeCategoryByTransactionId(cashflow, transactionId, expense, popEnvelope);
    }
    else {
        // If a category is excluded, we should only change the selected transaction categroy
        // from the excluded list, even if it has more transactions with same
        // business name. In adittion, we need to change all of the unexcluded categories that
        // belongs to the business name.
        if (_isExcludedTransaction(cashflow, transactionId)) {
            _changeCategoryByTransactionId(cashflow, transactionId, expense, popEnvelope);
        }
        _changeCategoryByBusinessName(cashflow, businessName, expense, popEnvelope);
    }
}
exports.changeCategory = changeCategory;
function _changeCategoryByTransactionId(cashflow, transactionId, expense, popEnvelope) {
    const transaction = utils_1.getTransactionById(cashflow, transactionId);
    _changeTransactionCategory(cashflow, transaction, expense, popEnvelope);
}
function _changeCategoryByBusinessName(cashflow, businessName, expense, popEnvelope) {
    const transactionsToChange = utils_1.getTransactionsByBusinessName(cashflow, businessName);
    lodash_1.default.forEach(transactionsToChange, transaction => {
        _changeTransactionCategory(cashflow, transaction, expense, popEnvelope);
    });
}
function _changeTransactionCategory(cashflow, transaction, expense, popEnvelope) {
    // eslint-disable-next-line no-param-reassign
    transaction[consts_1.EXPENSE_FIELD_NAME] = expense;
    const sourceTransactions = utils_1.findSourceTransactionsByTransactionId(cashflow, transaction.transactionId);
    if (popEnvelope) {
        popTransactionAndContainingEnvelope(cashflow, transaction.transactionId, sourceTransactions);
    }
    else {
        popTransaction(cashflow, transaction.transactionId, sourceTransactions);
    }
    if (expense === consts_1.ECONOMY_EXPENSE_CATEGORY) { // deprecated code - expense can't be Economy any more - economy is tracking category
        const envelope = utils_1.findEconomyEnvelope(transaction.transactionDate, cashflow.budgetDate, cashflow.envelopes);
        if (envelope) {
            envelope.actuals.push(transaction);
        }
    }
    else {
        const targetTransactions = utils_1.findTargetTransactionsByExpenseCategory(cashflow, expense);
        if (expense === consts_1.VARIABLE_EXPENSE_CATEGORY) {
            lodash_1.default.extend(transaction, { placement: 'variable' });
        }
        targetTransactions.push(transaction);
    }
}
function moveFromTracking(cashflow, matchBy, value) {
    const transactionsToChange = _getTransactionsByMatchBy(cashflow, matchBy, value);
    lodash_1.default.forEach(transactionsToChange, transaction => {
        _moveTransactionToVariable(cashflow, transaction, false);
    });
}
exports.moveFromTracking = moveFromTracking;
function _getTransactionsByMatchBy(cashflow, matchBy, value) {
    switch (matchBy) {
        case consts_1.MATCH_BY_TYPE.TRANSACTION_ID:
            return [utils_1.getTransactionById(cashflow, value)].filter((t) => !lodash_1.default.isNil(t));
        case consts_1.MATCH_BY_TYPE.EXPENSE:
            return utils_1.getTransactionsByExpense(cashflow, value);
        case consts_1.MATCH_BY_TYPE.PAYMENT_APP_ADDRESSEE:
            return utils_1.getTransactionsByPaymentAppAddressee(cashflow, value);
        case consts_1.MATCH_BY_TYPE.BUSINESS_NAME:
            return utils_1.getTransactionsByBusinessName(cashflow, value);
        default:
            throw new ts_essentials_1.UnreachableCaseError(matchBy);
    }
}
function changeTransactionCategory(cashflow, trackingCategoryId, matchBy, value, popEnvelope) {
    if (matchBy === consts_1.MATCH_BY_TYPE.TRANSACTION_ID) {
        _changeTrackingCategoryByTransactionId(cashflow, value, trackingCategoryId, popEnvelope);
    }
    else if (matchBy === consts_1.MATCH_BY_TYPE.EXPENSE) {
        _changeTrackingCategoryByExpense(cashflow, value, trackingCategoryId, popEnvelope);
    }
    else if (matchBy === consts_1.MATCH_BY_TYPE.PAYMENT_APP_ADDRESSEE) {
        _changeTrackingCategoryByPaymentAppAddressee(cashflow, value, trackingCategoryId, popEnvelope);
    }
    else if (matchBy === consts_1.MATCH_BY_TYPE.BUSINESS_NAME) {
        _changeTrackingCategoryByBusinessName(cashflow, value, trackingCategoryId, popEnvelope);
    }
    else {
        throw new ts_essentials_1.UnreachableCaseError(matchBy);
    }
}
exports.changeTransactionCategory = changeTransactionCategory;
function setTransactionComment(cashflow, transactionId, comment) {
    const transaction = utils_1.getTransactionById(cashflow, transactionId);
    if (transaction) {
        transaction.customerComment = comment;
    }
}
exports.setTransactionComment = setTransactionComment;
function setSequenceComment(cashflow, sequenceId, comment) {
    const envelope = utils_1.getEnvelopeBySequenceId(cashflow, sequenceId);
    if (envelope) {
        envelope.sequenceCustomerComment = comment;
    }
}
exports.setSequenceComment = setSequenceComment;
function splitTransaction(cashflow, transactionId, slices, actionType) {
    const originalTransaction = utils_1.getTransactionById(cashflow, transactionId);
    // remove all previouslySplit
    const oldSplits = utils_1.getTransactionBySplitFrom(cashflow, transactionId);
    lodash_1.default.forEach(oldSplits, oldSplit => {
        const sourceTransactions = utils_1.findSourceTransactionsByTransactionId(cashflow, oldSplit.transactionId);
        popTransaction(cashflow, oldSplit.transactionId, sourceTransactions);
    });
    if (actionType === 'delete') {
        const { placementBeforeSplit, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
        excludeReason, ...transaction } = popTransactionAndContainingEnvelope(cashflow, transactionId, cashflow.excluded);
        const originalEnvelope = (placementBeforeSplit === null || placementBeforeSplit === void 0 ? void 0 : placementBeforeSplit.placement) === 'trackingCategory'
            ? placementBeforeSplit.trackingCategoryId : placementBeforeSplit === null || placementBeforeSplit === void 0 ? void 0 : placementBeforeSplit.placement;
        const targetTransactions = transaction.isIncome ? cashflow.variableIncomeTransactions
            : utils_1.findTargetTransactionsByTrackingCategory(cashflow, originalEnvelope, transaction.transactionWeekInMonth);
        transaction.placement = placementBeforeSplit.placement;
        targetTransactions.push(transaction);
    }
    else { // 'create' and 'update'
        if (!originalTransaction) {
            return;
        }
        lodash_1.default.forEach(lodash_1.default.filter(slices, slice => slice.amount > 0), slice => {
            const incomeAmount = originalTransaction.isIncome ? slice.amount : 0;
            const billingAmount = originalTransaction.isIncome ? 0 : slice.amount;
            const newTransaction = {
                ...originalTransaction,
                transactionId: slice.transactionId,
                incomeAmount,
                billingAmount,
                splitFrom: transactionId,
            };
            const targetTransactions = originalTransaction.isIncome ? cashflow.variableIncomeTransactions
                : cashflow.variableTransactions;
            targetTransactions.push(newTransaction);
        });
        const popEnvelope = false; // Should be true if splitting a fixed transaction
        const excludedTransaction = excludeExpense(cashflow, transactionId, popEnvelope, enums_1.ExcludeReason.Logic);
        if (actionType === 'create') {
            lodash_1.default.extend(excludedTransaction, {
                placementBeforeSplit: {
                    placement: originalTransaction.placement,
                    trackingCategoryId: originalTransaction.trackingCategory && originalTransaction.trackingCategory.id,
                },
            });
        }
    }
}
exports.splitTransaction = splitTransaction;
// should be a stronger rule than business name
function _changeTrackingCategoryByTransactionId(cashflow, transactionId, trackingCategoryId, popEnvelope) {
    const transaction = utils_1.getTransactionById(cashflow, transactionId);
    _changeTransactionTrackingCategory(cashflow, transaction, trackingCategoryId, popEnvelope);
}
// should be a weaker rule than transaction id
function _changeTrackingCategoryByBusinessName(cashflow, businessName, trackingCategoryId, popEnvelope) {
    const transactionsToChange = utils_1.getTransactionsByBusinessName(cashflow, businessName);
    lodash_1.default.forEach(transactionsToChange, transaction => {
        _changeTransactionTrackingCategory(cashflow, transaction, trackingCategoryId, popEnvelope);
    });
}
function _changeTrackingCategoryByExpense(cashflow, expense, trackingCategoryId, popEnvelope) {
    const transactionsToChange = utils_1.getTransactionsByExpense(cashflow, expense);
    lodash_1.default.forEach(transactionsToChange, transaction => {
        _changeTransactionTrackingCategory(cashflow, transaction, trackingCategoryId, popEnvelope);
    });
}
function _changeTrackingCategoryByPaymentAppAddressee(cashflow, paymentAppAddressee, trackingCategoryId, popEnvelope) {
    const transactionsToChange = utils_1.getTransactionsByPaymentAppAddressee(cashflow, paymentAppAddressee);
    lodash_1.default.forEach(transactionsToChange, transaction => {
        _changeTransactionTrackingCategory(cashflow, transaction, trackingCategoryId, popEnvelope);
    });
}
function _changeTransactionTrackingCategory(cashflow, transaction, trackingCategoryId, popEnvelope) {
    const sourceTransactions = utils_1.findSourceTransactionsByTransactionId(cashflow, transaction.transactionId);
    if (popEnvelope) {
        popTransactionAndContainingEnvelope(cashflow, transaction.transactionId, sourceTransactions);
    }
    else {
        popTransaction(cashflow, transaction.transactionId, sourceTransactions);
    }
    const targetTransactions = utils_1.findTargetTransactionsByTrackingCategory(cashflow, trackingCategoryId, transaction.transactionWeekInMonth);
    lodash_1.default.extend(transaction, { placement: 'trackingCategory', trackingCategory: { id: trackingCategoryId } });
    targetTransactions.push(transaction);
}
function _moveTransactionToVariable(cashflow, transaction, popEnvelope) {
    const sourceTransactions = utils_1.findSourceTransactionsByTransactionId(cashflow, transaction.transactionId);
    if (popEnvelope) {
        popTransactionAndContainingEnvelope(cashflow, transaction.transactionId, sourceTransactions);
    }
    else {
        popTransaction(cashflow, transaction.transactionId, sourceTransactions);
    }
    const targetTransactions = cashflow.variableTransactions;
    lodash_1.default.extend(transaction, { placement: 'variable' });
    targetTransactions.push(transaction);
}
class NotFoundInCashflowError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.NotFoundInCashflowError = NotFoundInCashflowError;
function _assertIndex(index, identifier) {
    if (index === -1) {
        throw new NotFoundInCashflowError(`Got undefined object for ${identifier}`);
    }
}
function setIncomePredictionAmount(cashflow, amount) {
    cashflow.setVariableIncomePredictionAmount(-Math.abs(amount));
}
exports.setIncomePredictionAmount = setIncomePredictionAmount;
//# sourceMappingURL=actions.js.map